export default [
    {
        //蛋糕叔叔支付页
        path:`/dgPaymentResult`,
        name:'dgPaymentResult',
        meta: {
            title: "支付页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component:()=>import("@/views/cake/UncleCake.vue")
    },
    {
        path: "/cakeOrder/:id",
        name: "cakeOrder",
        meta: {
            title: "订单",
            keepAlive: false,
            footer: false,
            home:false,
            auth: true
        },
       component: ()=>import ("@views/cake/cakeOrder.vue")
    },

    {
        path:'/UncleCakeDetail/:id',
        name:'UncleCakeDetail',
        meta:{
            title:'蛋糕详情',
            keepAlive:false,
            footer:false,
            home:true,
            backgroundColor:"#f5f5f5",
        },
        component:()=>import("@views/cake/UncleCakeDetail.vue")
    },
    {
        path: "/dglogistics/:id",
        name: "Logistics",
        meta: {
          title: "物流信息",
          keepAlive: true,
          auth: true
        },
        component: () => import("@views/cake/Logistics.vue")
    },
    {
        //蛋糕叔叔支付页
        path:`/dgVirtualPayment`,
        name:'dgVirtualPayment',
        meta: {
            title: "支付页面",
            keepAlive: false,
            footer: false,
            movieFooter: false,
            home:false
        },
        component:()=>import("@/views/cake/dgPayment.vue")
    },
    //卡劵订单详情
    {
        path:'/UncleCodeDetail/:id',
        name:'UncleCakeDetail',
        meta:{
            title:'蛋糕详情',
            keepAlive:false,
            footer:false,
            home:true,
            backgroundColor:"#f5f5f5",
        },
        component:()=>import("@views/cake/dgcodeDetail.vue")
    },
];